import {getSuperstarData} from "./superstar.js";
import {
    FeudParticipantsHash, Feuds,
    MatchContracts,
    Matches,
    MatchesHash, Negotiations, Rosters,
    Streaks,
    Superstars, TagTeams,
    TagTeamsHash, TalentRequests,
    Tournaments
} from "./models.js";

function TagTeam(name, temporary = false, trio = false) {
    // Booleans
    const trioTagTeam = false;
    const factionTagTeam = false;
    const objectName = 'tagTeam';

    // Integer
    const winsCounter = 0;
    const lossesCounter = 0;
    const wins = 0;
    const losses = 0;
    const winsTemporary = 0;
    const lossesTemporary = 0;
    const tournamentSeed = null;
    const tournamentPoints = null;

    // Foreign keys
    const rosterId = null;

    // Pronouns
    const pronoun = 'they';
    const possessivePronoun = 'their';
    const objectivePronoun = 'them';

    return {
        name,
        objectName,
        temporary,
        trio,
        trioTagTeam,
        factionTagTeam,
        winsCounter,
        lossesCounter,
        wins,
        losses,
        winsTemporary,
        lossesTemporary,
        tournamentSeed,
        tournamentPoints,
        rosterId,
        pronoun,
        possessivePronoun,
        objectivePronoun,
    };
}

async function getTagTeamData(tagTeam) {
    let tagTeamData = JSON.parse(JSON.stringify(tagTeam));
    let tagTeamSuperstars = await getTagTeamSuperstars(tagTeam);
    tagTeamData['superstars'] = await Promise.all(
        tagTeamSuperstars.map(s => getSuperstarData(s))
    );
    return tagTeamData;
}

async function addTagTeam(name, superstars, trio = false, temporary = false) {
    // Create tagTeam, add superstars
    let tagTeam = TagTeam(name, temporary, trio);
    TagTeams.insert(tagTeam);
    addTagTeamSuperstars(tagTeam, superstars);
    return tagTeam;
}

function addTagTeamSuperstars(tagTeam, superstars) {
    let tagTeamHashes = superstars.map(s => {
        return {tagTeamId: tagTeam.$loki, superstarId: s.$loki}
    });
    return TagTeamsHash.insert(tagTeamHashes);
}

async function removeTagTeamSuperstars(tagTeam) {
    return TagTeamsHash.findAndRemove({'tagTeamId': tagTeam.$loki});
}

async function removeSuperstarFromTagTeam(tagTeam, superstar) {
    return TagTeamsHash.findAndRemove({'tagTeamId': tagTeam.$loki, 'superstarId': superstar.$loki});
}

async function getTagTeamSuperstars(tagTeam) {
    const tagTeamHashes = TagTeamsHash.find({'tagTeamId': tagTeam.$loki});
    const superstarIds = tagTeamHashes.map(x => {
        return x.superstarId
    });
    return Superstars.find({'$loki': {'$in': superstarIds}});
}

async function getTagTeamMatches(tagTeam) {
    const matchHashes = MatchesHash.find({'tagTeamId': tagTeam.$loki});
    const matchIds = matchHashes.map(x => {
        return x.matchId
    });
    return Matches.find({'$loki': {'$in': matchIds}});
}

function addTagTeamMatchContracts(tagTeam, matchContracts) {
    matchContracts.forEach(c => {
        c.tagTeamId = tagTeam.$loki
    });
}

function removeTagTeamMatchContracts(tagTeam, matchContracts) {
    matchContracts.forEach(c => {
        c.tagTeamId = null
    });
}

function getTagTeamMatchContracts(tagTeam) {
    return MatchContracts.find({'tagTeamId': tagTeam.$loki});
}

function addTagTeamStreaks(tagTeam, streaks) {
    streaks.forEach(c => {
        c.tagTeamId = tagTeam.$loki
    });
}

function removeTagTeamStreaks(tagTeam, streaks) {
    streaks.forEach(c => {
        c.tagTeamId = null
    });
}

function getTagTeamStreaks(tagTeam) {
    return Streaks.find({'tagTeamId': tagTeam.$loki});
}

function addTagTeamWonTournaments(tagTeam, tournaments) {
    tournaments.forEach(c => {
        c.winnerTagTeamId = tagTeam.$loki
    });
}

function removeTagTeamWonTournaments(tagTeam, tournaments) {
    tournaments.forEach(c => {
        c.winnerTagTeamId = null
    });
}

function getTagTeamWonTournaments(tagTeam) {
    return Tournaments.find({'winnerTagTeamId': tagTeam.$loki});
}

function addTagTeamNegotiations(tagTeam, negotiations) {
    negotiations.forEach(c => {
        c.tagTeamId = tagTeam.$loki
    });
}

function removeTagTeamNegotiations(tagTeam, negotiations) {
    negotiations.forEach(c => {
        c.tagTeamId = null
    });
}

function getTagTeamNegotiations(tagTeam) {
    return Negotiations.find({'tagTeamId': tagTeam.$loki});
}

function addTagTeamTalentRequests(tagTeam, talentRequests) {
    talentRequests.forEach(c => {
        c.tagTeamId = tagTeam.$loki
    });
}

function removeTagTeamTalentRequests(tagTeam, talentRequests) {
    talentRequests.forEach(c => {
        c.tagTeamId = null
    });
}

function getTagTeamTalentRequests(tagTeam) {
    return TalentRequests.find({'tagTeamId': tagTeam.$loki});
}

async function getTagTeamFeuds(tagTeam) {
    const feudHashes = FeudParticipantsHash.find({'tagTeamId': tagTeam.$loki});
    const feudIds = feudHashes.map(x => {
        return x.feudId
    });
    return Feuds.find({'$loki': {'$in': feudIds}});
}

function getTagTeamRoster(tagTeam) {
    return Rosters.find({'$loki': tagTeam.rosterId})[0];
}

export { TagTeam, getTagTeamData, addTagTeam, addTagTeamSuperstars, getTagTeamSuperstars, getTagTeamMatches,
    addTagTeamMatchContracts, removeTagTeamMatchContracts, getTagTeamMatchContracts, addTagTeamStreaks,
    removeTagTeamStreaks, getTagTeamStreaks, addTagTeamWonTournaments, removeTagTeamWonTournaments,
    getTagTeamWonTournaments, addTagTeamNegotiations, removeTagTeamNegotiations, getTagTeamNegotiations,
    addTagTeamTalentRequests, removeTagTeamTalentRequests, getTagTeamTalentRequests, getTagTeamFeuds,
    removeTagTeamSuperstars, getTagTeamRoster, removeSuperstarFromTagTeam }
